define('NVT.anuualupdateform.anuualupdateformNewContact.View'
, [
    'Backbone'
  , 'nvt_anuualupdateform_new_contact.tpl'
  , 'Backbone.FormView'
  , 'GlobalViews.Message.View'
  ,	'underscore'
  ,	'jQuery'
  , 'Utils'


  ]
, function
  (
    Backbone
  , nvt_myorganisation_new_contact_tpl
  , BackboneFormView
  , MessageView
  ,	_
  ,	jQuery
  , Utils

  )
{
  'use strict';

    return Backbone.View.extend({
           
        template: nvt_myorganisation_new_contact_tpl

        , title: Utils.translate('New Contact')

        ,initialize: function(options)
            {
                this.options = options;
                this.getjsonrequest = options.getjsonrequest;
                this.application = options.application;
                this.page_header = "New Contact";	
                this.modalClass ='modal-md';  
                var self = this;
                BackboneFormView.add(this);
            }

        ,    events: 
            {
                'change [data-action="indstatusregined"]': 'IndstStusRegined',
                'submit form': 'saveTheForm',
                'click [data-action="whateachrolemeans"]': 'openWhateachrolemeansModel',
                'input [name="nus_ems_name"]': 'forceUppercase',
                'input [name="nus_ems_name_last"]': 'forceUppercase',
                'input [name="nus_job_title"]': 'forceUppercase'
            }   
            
           ,   forceUppercase: function (e)
            {
                var el = e.target;
                var pos = el.selectionStart;
                el.value = el.value.toUpperCase();
                el.setSelectionRange(pos, pos);
            }

        ,	openWhateachrolemeansModel: function (e){

                e.preventDefault();
                var self = this;
                var application = this.application;

                jQuery('.nvt-what-each-role-overlay').remove();

                var roles = [
                    { icon: '&#128119;', name: 'C-Suite', desc: 'Chief Executive Officer / Managing Director / Executive Director / General Manager / Key organisational decision contact.' },
                    { icon: '&#129534;', name: 'Finance', desc: 'Receives electronic invoice / SOA on membership from SBF and makes payment.' },
                    { icon: '&#128101;', name: 'HR', desc: 'Main contact point for Membership Update Exercises and eDMs, and disseminates them to company staff.' },
                    { icon: '&#128227;', name: 'Liaison Officer', desc: 'Receives latest information / eDMs on SBF activities and disseminates them to company staff.' },
                    { icon: '&#128231;', name: 'Participants and eDM Recipients', desc: 'Receives SBF event invitations, updates, and general email communications, and may be invited to participate in events.' },
                    { icon: '&#128221;', name: 'Exemption Application Contact', desc: 'Contact point regarding exemption applications (e.g. submission, clarifications, or status updates).' }
                ];

                var $content = jQuery(
                    '<div style="font-size:0.92rem; line-height:1.6; color:#0e2147;">' +
                        // '<p style="margin:0 0 1.1rem; color:#334155;">' + Utils.translate('Each Contact Category reflects the role a contact plays for your organisation with SBF. A contact may be tagged with more than one category.') + '</p>' +
                        '<div style="display:flex; flex-direction:column; gap:0.75rem;">' +
                            _.map(roles, function(role)
                            {
                                return '<div style="display:flex; align-items:flex-start; gap:0.7rem; background:#f8fafc; border:1px solid #e2e8f0; border-radius:10px; padding:0.8rem 1rem;">' +
                                    '<span style="flex-shrink:0; width:1.8rem; height:1.8rem; border-radius:50%; background:#eef6fb; color:#0e6ba8; display:flex; align-items:center; justify-content:center; font-size:0.95rem;">' + role.icon + '</span>' +
                                    '<div>' +
                                        '<strong style="display:block; color:#0e2147; font-size:0.9rem; margin-bottom:0.15rem;">' + Utils.translate(role.name) + '</strong>' +
                                        '<span style="color:#334155;">' + Utils.translate(role.desc) + '</span>' +
                                    '</div>' +
                                '</div>';
                            }).join('') +
                        '</div>' +
                    '</div>'
                );

                var $overlay = jQuery(
                    '<div class="nvt-what-each-role-overlay" style="position:fixed; inset:0; background:rgba(0,0,0,0.45); display:flex; align-items:center; justify-content:center; z-index:999999999; padding:1.5rem;">' +
                        '<div class="nvt-what-each-role-dialog" style="max-width:560px; width:100%; max-height:85vh; overflow-y:auto; background:#ffffff; border-radius:12px; box-shadow:0 20px 60px rgba(0,0,0,0.25); padding:1.75rem 2rem; position:relative;">' +
                            '<button type="button" data-action="what-each-role-close" style="position:absolute; top:1rem; right:1.25rem; background:none; border:none; font-size:1.4rem; line-height:1; color:#9ca3af; cursor:pointer;" aria-label="Close">&#10005;</button>' +
                            '<h2 style="margin:0 0 1rem 0; font-size:1.15rem; font-weight:700; color:#0e2147;">' + Utils.translate('What Each Role Means?') + '</h2>' +
                        '</div>' +
                    '</div>'
                );

                $overlay.find('.nvt-what-each-role-dialog').append($content);

                $overlay.on('click', '[data-action="what-each-role-close"]', function (e)
                {
                    e.preventDefault();
                    $overlay.remove();
                });

                jQuery('body').append($overlay);
            }

        ,   IndstStusRegined: function (e)
            {
                e.preventDefault();
                var self=this;
                var id= jQuery(e.target).val();
                //jQuery(".classresigned").text('');
                jQuery(".classresigned").hide();
                if( id == '3')
                {
                    jQuery(".classresigned").show();
                   // var getreginedtext = SC.CONFIGURATION.MyCoolModule.resigned || '';
                   // jQuery(".classresigned").text(getreginedtext)
                }             
            }

        ,   validateEmail : function (email) {
                var self = this;
                var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
                return re.test(email);
            }

        ,   validatePhoneNumber : function(phone) {
            var self = this;
            var cleaned = phone.replace(/[\s()-]/g, '');
            var regex = /^\+?[1-9]\d{6,14}$/;
            return regex.test(cleaned);
        }

        ,   saveTheForm: function(e)
            {
                e.preventDefault();
                e.stopImmediatePropagation();
                var self = this,
                	$target = jQuery(e.target),
			    	getfielddata = $target.serializeObject();
                    
                if(!getfielddata.nus_ems_name.trim() && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Given name is required', 'error','nus_ems_name');
                }
                else if(!getfielddata.nus_ems_name_last.trim() &&getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Surname is required', 'error','nus_ems_name_last');
                }
                else if(!getfielddata.nus_job_title.trim() && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Job title is required', 'error','nus_job_title');
                }
                else if((getfielddata.nus_phone_no =='' || getfielddata.nus_phone_no.length < 8) && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Business Contact number is required', 'error','nus_phone_no');
                }
                else if((getfielddata.nus_phone_no !='' || getfielddata.nus_phone_no.length > 8) && !self.validatePhoneNumber(getfielddata.nus_phone_no) && getfielddata.custentity_contact_status !="3")
                {
                    self.showMessage('Business Contact number is Invalid', 'error','nus_phone_no');
                }
                else if(!getfielddata.formtypes || !getfielddata.nus_email_address.trim())
                {
                    self.showMessage('The email address used for login is required.', 'error','nus_email_address');  
                }
                else if(!self.validateEmail(getfielddata.nus_email_address))
                {
                    self.showMessage('The email address used for login is required.', 'error','nus_email_address');  
                }
                else if(!getfielddata.nus_contactdesignation)
                {
                    self.showMessage('Please select at least one Contact Category.', 'error','nus_contactdesignation');
                }
                // else if(!getfielddata.email_confirma_know)
                // {
                //     self.showMessage('Please verify this information is valid or not.', 'error','email_confirma_know');
                // }
                else
                    {
                        var promise = BackboneFormView.saveForm.apply(this, arguments);
                        this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);
                        return promise && promise.then
                        (
                            function(responce)
                            {
                                if (responce.successMessage)
                                {
                                    self.showMessage(responce.successMessage, 'success');
                                }
                                else {
                                    self.showMessage(responce.errorMessage, 'error')
                                }

                                return false;   
                            }
                        );
                    }              
               
            }

        , showMessage: function(message, type, field)
            {
                jQuery('.global-views-message-error').remove(); 
                jQuery('.global-views-message-success').remove(); 

                var messageView = new MessageView
                ({
                        message: message
                    ,   type: type
                    ,   closable: type =='error' ? true : false
                });
                if (typeof field !== 'undefined')
                {
                    this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
                }
                else if (type =='error'){
                    this.application.getLayout().$('form').append(messageView.render().$el);
                }
                else
                {
                    this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                    setTimeout(function() {
                        jQuery("[data-dismiss=modal]").trigger({ type: "click" });
                    }, 1000);
                }
            }    
            
        ,getContext: function() {
            
            var self = this;
            var getdesgRemovelist = SC.CONFIGURATION.MyOrganisation.getDesignation || '';
                getdesgRemovelist= getdesgRemovelist.split(",") || [];
            var newgetdesglist = this.options.contactCategory;
                if(newgetdesglist){
                    newgetdesglist = newgetdesglist.filter(item => !getdesgRemovelist.includes(item.desgid));
                }

            return {
        
               title : this.title,

               accosiate_id : this.options.accosiate_id || null,

               getinternalid : this.options.profile.internalid || null,

               getfirstname : '',

               getlastname : '',

               getJobTitle: '',

               getPhoneNo : '',

               getEmailAddress : '',

               getdesglist : newgetdesglist || '',

               getdesignation : '',

               isindividualstatusActive :  this.options.profile.individualstatus === 'Active',

               isindividualstatusResigned :  this.options.profile.individualstatus === 'No longer with Organisation',

               isresignedCaption : SC.CONFIGURATION.MyCoolModule.resigned || '',
               
           }
         }        

    });
});
